import cloneDeep from 'lodash.clonedeep';
import { AccessFunctionFormData } from 'data/accessFunction/accessFunction.types';
import { FormTemplate } from 'data/template/template.types';

export function handleModelFieldUpdateForNokiaCMG(
    data: Partial<AccessFunctionFormData>,
    template: FormTemplate | undefined,
    modelNumber: string,
): Partial<AccessFunctionFormData> {
    if (template && (template.key === 'NOKIA_CMG')) {
        const clonedData = cloneDeep(data);
        if (modelNumber !== 'SMF_C' && clonedData.provisioningInterfaces?.length) {
            clonedData.provisioningInterfaces[0].afx1servertlsprofile = '';
            clonedData.provisioningInterfaces[0].aflit3ipaddr = '';
            clonedData.provisioningInterfaces[0].aflit3port = '';
        }
        return clonedData;
    }
    return data;
}

export function handleModelFieldUpdateForMokiaCMGU(
    data: Partial<AccessFunctionFormData>,
    template: FormTemplate | undefined,
    modelNumber: string,
): Partial<AccessFunctionFormData> {
    if (template && (template.key === 'NOKIA_CMG_U')) {
        const clonedData = cloneDeep(data);
        if (modelNumber !== 'UPF_U' && clonedData.provisioningInterfaces?.length) {
            clonedData.provisioningInterfaces[0].afx1servertlsprofile = '';
            clonedData.provisioningInterfaces[0].afnfid = '';
            clonedData.provisioningInterfaces[0].aflit3ipaddr = '';
            clonedData.provisioningInterfaces[0].aflit3port = '';
            clonedData.provisioningInterfaces[0].aflit3upfpeerid = '';
            clonedData.provisioningInterfaces[0].aflit3router = '';
        } else if (modelNumber === 'UPF_U' && clonedData.provisioningInterfaces?.length) {
            clonedData.provisioningInterfaces[0].afx3srcipaddrField = '';
            clonedData.provisioningInterfaces[0].pfcplisharedkey = '';
        }
        return clonedData;
    }
    return data;
}
